import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
    routes: [{
        path: '/',
        component: () => import('@/views/index.vue'),
        meta: {
            title: 'GE AND ME实验室'
        }
    }, {
        path: '/pdf',
        component: () => import('@/views/pdf.vue'),
        meta: {
            title: ''
        }
    }, {
        path: '/candidate',
        component: () => import('@/views/candidate.vue'),
        meta: {
            title: ''
        }
    }, {
        path: '/GE_vote',
        redirect: '/'
    }, {
        path: '*',
        redirect: '/404'
    }]
});
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})
export default router;
